import React, { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { sendMail } from "../service";
const Form = () => {
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [data, setData] = useState<{
    email: string;
    message: string;
    phone: string;
  }>({
    email: "",
    message: "",
    phone: "",
  });
  const handleValueChange = (newValue: any) => {
    console.log("newValue:", newValue);
    setDate(newValue);
  };
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const res = await sendMail({ ...data, date });
    if (res.status !== 200) {
      setError(true);
    } else {
      setSuccess(true);
    }
  };

  return (
    <div
      id="connect"
      className="flex items-center justify-center w-full py-20 lg:px-8"
    >
      <div className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="">
          <h1
            data-aos="fade-up"
            className="font-extrabold w-full font-gunterz lg:px-20 pt-4 py-3 rounded-lg text-[17px] text-black bg-white text-center mb-5 lg:text-[30px]"
          >
            BOOK FOR YOUR NEXT EVENT
          </h1>
          {error && (
            <p className="text-center text-xl text-red-500">
              Something went wrong, please try again after refresh
            </p>
          )}
          {!success ? (
            <form
              data-aos="fade-up"
              onSubmit={onSubmit}
              className="mb-0 mt-10 space-y-4 rounded-lg shadow-lg"
            >
              <div className="flex justify-center">
                <h2 className="text-white text-2xl">Enter your details</h2>
              </div>
              <div className="flex flex-col w-full md:flex-row gap-4">
                <label
                  htmlFor="UserEmail"
                  className="relative block w-full overflow-hidden bg-black rounded-lg border-2 border-white py-5 px-2 shadow-sm"
                >
                  <input
                    type="email"
                    id="UserEmail"
                    placeholder="Email"
                    name="email"
                    onChange={handleInput}
                    className="peer h-8 w-full border-none text-white text-xl bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0"
                  />

                  <span className="absolute start-3 top-3 -translate-y-1/2 text-gray-400 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-lg peer-focus:top-3 peer-focus:text-xs">
                    Email
                  </span>
                </label>
                <label
                  htmlFor="phone"
                  className="relative block w-full overflow-hidden bg-black rounded-lg border-2 border-white py-5 px-2 shadow-sm"
                >
                  <input
                    type="text"
                    id="phone"
                    placeholder="Phone"
                    name="phone"
                    required
                    onChange={handleInput}
                    className="peer h-8 w-full border-none text-white bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 text-xl"
                  />

                  <span className="absolute start-3 top-3 -translate-y-1/2 text-sm text-gray-400 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-lg peer-focus:top-3 peer-focus:text-xs">
                    Phone
                  </span>
                </label>
              </div>
              <label
                htmlFor="UserEmail"
                className="block text-sm font-medium text-white"
              >
                Select your date:
              </label>
              <Datepicker
                primaryColor="blue"
                value={date}
                onChange={handleValueChange}
                showShortcuts={true}
                showFooter={true}
              />
              <button
                type="submit"
                className="inline-block w-full rounded-lg bg-gradient p-[1px] focus:outline-none focus:ring active:text-opacity-75"
              >
                <span className="block rounded-lg font-light font-gotham text-[20px] bg-black text-white py-3 hover:bg-white duration-300 hover:text-black transition active:translate-y-1">
                  Get quotation
                </span>
              </button>
            </form>
          ) : (
            <div
              data-aos="fade-up"
              className="text-center my-10 flex justify-center text-white"
            >
              <div className="max-w-sm rounded-lg bg-gray-800 px-6 py-4">
                <p className="text-xl">
                  Thank You! <br /> Your message has been sent!
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Form;
